import React from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import Modal from "aldoo-ra/Modal"
import { TrashIcon } from "@heroicons/react/24/outline"

/**
 * Confirmation modal for delete actions
 */
const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, userCount, isBulk = false }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="admin_centered"
      title="Confirm Deletion"
      className="max-w-md"
    >
      <div className="space-y-4">
        <Typography variant="admin_body">
          {isBulk
            ? `Are you sure you want to delete ${userCount} selected user${userCount !== 1 ? 's' : ''}?`
            : `Are you sure you want to delete this user?`
          }
        </Typography>

        <Typography variant="admin_txt1_dim">
          This action will soft-delete the user{userCount !== 1 ? 's' : ''} and can be undone using the restore function.
        </Typography>

        <div className="flex justify-end gap-2 pt-4">
          <Button variant="admin_secondary" onClick={onClose}>
            Cancel
          </Button>

          <Button variant="admin_error" onClick={onConfirm}>
            <TrashIcon className="w-4 h-4 mr-1" />
            Delete {isBulk ? `${userCount} User${userCount !== 1 ? 's' : ''}` : 'User'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteConfirmationModal
